module.exports = __webpack_public_path__ + "static/img/laboratory7.94adba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory7.jpg
// module id = dzCX
// module chunks = 1